module.exports = __webpack_public_path__ + "static/media/star_empty.5c8e38b0.png";